import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from './createBaseQuery';
export interface IMediaPack {
  id?: string;
  title: string;
  description?: string;
  price: number;
  tokensPrice?: number;
  currency?: string;
  isActive?: boolean;
  sortOrder?: number;
  createdAt?: Date;
  mediaItems?: Array<{
    url: string;
    videoCoverUrl?: string;
    order?: number;
  }>;
  characterId?: string;
  scenarioId?: string;
  characterIds?: Record<string, string>;
  scenarioIds?: Record<string, string>;
  characterNames?: Record<string, string>;
  coverUrl?: string;
  isPurchased?: boolean;
  type: string;
}

export const mediaPacksApi = createApi({
  reducerPath: 'mediaPacksApi',
  baseQuery: createBaseQuery(),
  endpoints: (builder) => ({
    getAdminMediaPacks: builder.query<IMediaPack[], void>({
      query: () => ({
        url: '/admin/media-packs',
        method: 'GET',
        requiresAuth: true,
      }),
    }),

    getAdminMediaPack: builder.query<IMediaPack, { id: string }>({
      query: ({ id }) => ({
        url: `/admin/media-packs/${id}`,
        method: 'GET',
        requiresAuth: true,
      }),
    }),

    createMediaPack: builder.mutation<IMediaPack, IMediaPack>({
      query: (body) => ({
        url: '/admin/media-packs',
        method: 'POST',
        body,
        requiresAuth: true,
      }),
    }),

    updateMediaPack: builder.mutation<IMediaPack, { id: string; params: Partial<IMediaPack> }>({
      query: ({ id, params }) => ({
        url: `/admin/media-packs/${id}`,
        method: 'PUT',
        body: params,
        requiresAuth: true,
      }),
    }),

    deleteMediaPack: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/admin/media-packs/${id}`,
        method: 'DELETE',
        requiresAuth: true,
      }),
    }),

    getCharacterMediaPacks: builder.query<IMediaPack[], { id: string }>({
      query: ({ id }) => ({
        url: `/characters/${id}/media-packs`,
        method: 'GET',
      }),
    }),

    getScenarioMediaPacks: builder.query<IMediaPack[], { id: string }>({
      query: ({ id }) => ({
        url: `/scenarios/${id}/media-packs`,
        method: 'GET',
      }),
    }),

    purchaseMediaPack: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/media-packs/${id}/purchase`,
        method: 'POST',
        requiresAuth: true,
      }),
    }),

    getUserMediaPacks: builder.query<IMediaPack[], void>({
      query: () => ({
        url: '/me/media-packs',
        method: 'GET',
        requiresAuth: true,
      }),
    }),
  }),
});

export const {
  useGetAdminMediaPacksQuery,
  useGetAdminMediaPackQuery,
  useCreateMediaPackMutation,
  useUpdateMediaPackMutation,
  useDeleteMediaPackMutation,
  useGetCharacterMediaPacksQuery,
  useGetScenarioMediaPacksQuery,
  usePurchaseMediaPackMutation,
  useGetUserMediaPacksQuery,
} = mediaPacksApi; 